export default __webpack_public_path__ + "static-front/media/menuIcon.2d16852b.svg";